<div *transloco="let t" class="py-4">
	@if (finishedLoading()) {
		<div class="mt-4 flex flex-col">
			@for (currentPm of propertyManagementContacts(); track currentPm.id) {
				<h3 class="title">{{ t('documentTransfer.notificationMail') }}: {{ [currentPm.firstName, currentPm.name].join(' ') }}</h3>
				<div class="flex flex-row items-center content-start mb-4">
					@if (finishedLoadingMails()) {
						<mat-form-field class="w-[30%] mt-4">
							<mat-label>{{ t('customerManagement.detail.persons.emails') }}</mat-label>
							<mat-select (selectionChange)="setEmailToModel($event, currentPm)" [formControl]="mailsToUse.get(currentPm.id)">
								@for (currentMail of mailsByContact.get(currentPm); track currentMail) {
									<mat-option [value]="currentMail">
										{{ currentMail }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<button
							mat-fab
							color="primary"
							class="ml-4"
							(click)="openAddEmailDialog(currentPm)"
							title="{{ t('settings.devSettings.supportTools.newMail') }}">
							<mat-icon>add</mat-icon>
						</button>
					} @else {
						<div @fadeInUp class="flex flex-row justify-center">
							<mat-spinner color="primary"></mat-spinner>
						</div>
					}
				</div>
			}
		</div>
	} @else {
		<div @fadeInUp class="flex flex-row justify-center">
			<mat-spinner color="primary"></mat-spinner>
		</div>
	}
</div>
